import Link from "next/link"

import { useOrganization } from "@clerk/nextjs"
import { Button, Tooltip } from "@coval/ui"

import { TRACKING_EVENTS, useAnalytics } from "@/lib/analytics"
import { useQueryParams } from "@/hooks/useQueryParams"

const GITHUB_ACTION_URL = "https://github.com/coval-ai/coval-github-action"
const DOCS_URL = "https://docs.coval.ai"
const API_DOCS_URL = "https://docs.coval.ai/api-reference"
const MCP_DOCS_URL = "https://docs.coval.ai/mcp/overview"
const CLI_DOCS_URL = "https://docs.coval.ai/cli/overview"
const SKILLS_URL = "https://github.com/coval-ai/coval-external-skills/tree/main"

export function OverviewHeaderIcons() {
  const { organization } = useOrganization()
  const { trackEvent } = useAnalytics()
  const queryParams = useQueryParams()

  const handleDocsClick = () => {
    trackEvent(TRACKING_EVENTS.OVERVIEW.DOCS_CLICKED)
  }
  const handleApiDocsClick = () => {
    trackEvent(TRACKING_EVENTS.OVERVIEW.API_DOCS_CLICKED)
  }
  const handleCicdClick = () => {
    trackEvent(TRACKING_EVENTS.OVERVIEW.CICD_CLICKED)
  }
  const handleApiKeyClick = () => {
    trackEvent(TRACKING_EVENTS.OVERVIEW.API_KEY_CLICKED)
  }

  return (
    <div className="flex items-center gap-1">
      <Tooltip content="Documentation">
        <Button asChild variant="ghost" onClick={handleDocsClick}>
          <Link href={DOCS_URL} target="_blank" rel="noopener noreferrer">
            Docs
          </Link>
        </Button>
      </Tooltip>
      <Tooltip content="API Reference">
        <Button asChild variant="ghost" onClick={handleApiDocsClick}>
          <Link href={API_DOCS_URL} target="_blank" rel="noopener noreferrer">
            API
          </Link>
        </Button>
      </Tooltip>
      <Tooltip content="MCP Server">
        <Button asChild variant="ghost">
          <Link href={MCP_DOCS_URL} target="_blank" rel="noopener noreferrer">
            MCP
          </Link>
        </Button>
      </Tooltip>
      <Tooltip content="CLI">
        <Button asChild variant="ghost">
          <Link href={CLI_DOCS_URL} target="_blank" rel="noopener noreferrer">
            CLI
          </Link>
        </Button>
      </Tooltip>
      <Tooltip content="GitHub Action">
        <Button asChild variant="ghost" onClick={handleCicdClick}>
          <Link
            href={GITHUB_ACTION_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            CI/CD
          </Link>
        </Button>
      </Tooltip>
      <Tooltip content="Skills">
        <Button asChild variant="ghost">
          <Link href={SKILLS_URL} target="_blank" rel="noopener noreferrer">
            Skills
          </Link>
        </Button>
      </Tooltip>
      <Tooltip content="Manage API Keys">
        <Button asChild variant="ghost" onClick={handleApiKeyClick}>
          <Link
            href={queryParams.getHref(
              "/settings/api-keys",
              organization?.slug ?? undefined,
            )}
          >
            API Keys
          </Link>
        </Button>
      </Tooltip>
    </div>
  )
}
